import styled from 'styled-components';
import COLORS from 'styles/colors';
import { rem, weight } from 'styles/typography';

import BREAKPOINTS from 'styles/breakpoints';

const Position = styled.div`
  border-radius: 100%;
  width: 50px;
  height: 50px;
  font-size: ${rem(18)};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border: 3px solid ${COLORS.white};
  color: ${COLORS.white};

  ${BREAKPOINTS.small`
    width: 65px;
    height: 65px;
    font-size: ${rem(22)};
  `};
`;

const ContentContainer = styled.div`
  border-radius: 20px;
  padding: 5px 20px 10px 20px;
  width: 100%;
  margin-top: -25px;
  border: 2px solid ${COLORS.white};
  font-size: ${rem(18)};

  ${BREAKPOINTS.xsmall`
    padding: 10px 20px 20px 20px;
  `}

  ${BREAKPOINTS.small`
    font-size: ${rem(22)};
		border-radius: 100px;
		margin-top: 0;
		margin-left: -80px;
    padding: 0;
		display: flex;
    align-items: center;
    justify-content: space-between;
	`};
`;

const Player = styled.div`
  margin-bottom: 10px;
  color: ${COLORS.white};

  ${Position}, ${ContentContainer} {
    background-color: ${COLORS.lightblueGreen};
  }

  :nth-child(1) ${Position}, :nth-child(1) ${ContentContainer} {
    background: rgb(217, 188, 93);
    background: -moz-linear-gradient(
      180deg,
      rgba(217, 188, 93, 1) 0%,
      rgba(144, 125, 62, 1) 100%
    );
    background: -webkit-linear-gradient(
      180deg,
      rgba(217, 188, 93, 1) 0%,
      rgba(144, 125, 62, 1) 100%
    );
    background: linear-gradient(
      180deg,
      rgba(217, 188, 93, 1) 0%,
      rgba(144, 125, 62, 1) 100%
    );
  }

  :nth-child(2) ${Position}, :nth-child(2) ${ContentContainer} {
    background: rgb(200, 200, 200);
    background: -moz-linear-gradient(
      180deg,
      rgba(200, 200, 200, 1) 0%,
      rgba(117, 117, 117, 1) 100%
    );
    background: -webkit-linear-gradient(
      180deg,
      rgba(200, 200, 200, 1) 0%,
      rgba(117, 117, 117, 1) 100%
    );
    background: linear-gradient(
      180deg,
      rgba(200, 200, 200, 1) 0%,
      rgba(117, 117, 117, 1) 100%
    );
  }

  :nth-child(3) ${Position}, :nth-child(3) ${ContentContainer} {
    background-color: ${COLORS.blueGreen};
  }

  ${BREAKPOINTS.small`
    margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
	`};
`;

const PositionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 20px;

  ${BREAKPOINTS.xxsmall`
    gap: 10px;
    flex-direction: row;
  `};

  ${BREAKPOINTS.small`
    gap: 20px;
		padding-left: 80px;
		padding-top: 0;
		justify-content: flex-start;
	`};
`;

const Nickname = styled.div``;

const Border = styled.div`
  display: none;

  ${BREAKPOINTS.xxsmall`
    display: block;
    width: 1px;
    height: 15px;
    background-color: ${COLORS.white};
    flex-direction: row;
  `};

  ${BREAKPOINTS.small`
    height: 30px;
  `};
`;

const Location = styled.div``;

const Score = styled.div`
  display: flex;
  justify-content: center;
  font-weight: ${weight.bold};
  font-size: ${rem(18)};

  ${BREAKPOINTS.small`
    padding-right: 40px;
    font-size: ${rem(22)};
		text-align: right;
	`};
`;

const LeaderboardPlayer = ({ position, nickname, location, score }) => {
  return (
    <Player>
      <PositionContainer>
        <Position>{position}</Position>
      </PositionContainer>

      <ContentContainer>
        <Content>
          <Nickname>{nickname}</Nickname>

          <Border />

          <Location>{location}</Location>
        </Content>

        <Score>{score}</Score>
      </ContentContainer>
    </Player>
  );
};

export default LeaderboardPlayer;
